<template>
  <svg :width="width" :height="height" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4369_1276)">
      <path d="M36.8164 5.97754L38.7315 4.06246" stroke="#FF0064" stroke-width="1.52344" stroke-linecap="round" />
      <path d="M23.4963 5.97754L21.5813 4.06246" stroke="#FF0064" stroke-width="1.52344" stroke-linecap="round" />
      <path d="M19.2117 13.2031H16.5033" stroke="#FF0064" stroke-width="1.52344" stroke-linecap="round" />
      <path d="M41.8945 13.2031H44.6029" stroke="#FF0064" stroke-width="1.52344" stroke-linecap="round" />
      <path d="M38.8477 18.2812L40.7627 20.1963" stroke="#FF0064" stroke-width="1.52344" stroke-linecap="round" />
      <path d="M22.4805 18.2812L20.5654 20.1963" stroke="#FF0064" stroke-width="1.52344" stroke-linecap="round" />
      <path
        d="M30.7227 4.0625L33.5471 9.78453L39.8633 10.7077L35.293 15.1592L36.3716 21.448L30.7227 18.4773L25.0738 21.448L26.1523 15.1592L21.582 10.7077L27.8982 9.78453L30.7227 4.0625Z"
        stroke="#FF0064"
        stroke-width="1.52344"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2.28516 38.9033L13.6266 28.0711C15.1329 26.5746 16.8841 26.3455 17.5715 26.418H28.2406C30.4371 26.9835 30.1682 29.9417 28.2406 30.4203H20.4853H23.4888C24.2858 31.3042 26.0148 33.0302 27.4785 34.41M7.799 47.7344L13.4922 41.2525C14.4037 39.9184 16.8453 37.3633 19.3198 37.8157C21.7943 38.2682 26.9256 39.7734 29.1819 40.4694L46.4407 36.0756C47.7407 35.162 46.4407 32.3779 44.8717 32.3779C44.7241 32.4162 44.5592 32.4591 44.3786 32.5061M29.944 36.0167C30.3529 36.0762 30.7202 36.028 31.0647 35.9886C34.4009 35.1144 41.4446 33.2698 44.3786 32.5061M29.944 36.0167C29.4485 35.9447 28.8918 35.7145 28.2406 35.1186C28 34.8984 27.7436 34.6599 27.4785 34.41M29.944 36.0167L40.0303 30.5666M44.3786 32.5061C43.5538 30.3118 41.8533 29.9112 41.1062 29.9852L40.0303 30.5666M27.4785 34.41L36.8475 29.0716C37.505 28.7777 39.062 28.6651 40.0303 30.5666"
        stroke="#05070F"
        stroke-width="1.52344"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_4369_1276">
        <rect :width="width" :height="height" fill="white" transform="translate(0.75)" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
export default {
  name: 'PerksIllustration',
  props: {
    width: {
      type: Number,
      default: 48,
    },
    height: {
      type: Number,
      default: 48,
    },
  },
};
</script>
